<template>
    <span>
        <template v-if="header">
            {{ $t(`global.${header}`) }}
        </template>
    </span>
</template>

<script>
export default {
    props: {
        header: String
    }
};
</script>